var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getRequestId, updateRequest } from '../dataLayer';
import { parseUriQuery } from '../web';
import { doWhenP } from '../utils';
import { getCacheItem, setCacheItem } from '../cache';
const CACHE_KEY = 'previousMsclkIds';
/**
 * Update Bing Data
 * @returns {Promise}
 */
function updateBingData() {
    return __awaiter(this, void 0, void 0, function* () {
        const data = parseUriQuery();
        const requestId = getRequestId();
        const msclkid = data.msclkid || null;
        const cachedData = getCacheItem(CACHE_KEY) || {};
        if (!requestId || !msclkid || cachedData[msclkid])
            return null;
        return updateRequest(getRequestId(), { bing_data: data }).then(() => {
            cachedData[msclkid] = true;
            setCacheItem(CACHE_KEY, cachedData);
        });
    });
}
export function run() {
    return doWhenP(getRequestId).then(() => {
        updateBingData().catch(e => console.error('bing data request failed: ', e));
        window.addEventListener('popstate', updateBingData);
    });
}
//# sourceMappingURL=BingData.js.map